import { render, staticRenderFns } from "./RestoreFooterButton.vue?vue&type=template&id=5d49eddf&scoped=true&"
import script from "./RestoreFooterButton.vue?vue&type=script&lang=ts&"
export * from "./RestoreFooterButton.vue?vue&type=script&lang=ts&"
import style0 from "./RestoreFooterButton.vue?vue&type=style&index=0&id=5d49eddf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d49eddf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
